import { render, staticRenderFns } from "./biomicroscopy2.vue?vue&type=template&id=f0c382ce&scoped=true&"
import script from "./biomicroscopy2.vue?vue&type=script&lang=js&"
export * from "./biomicroscopy2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c382ce",
  null
  
)

export default component.exports